import { NeedsDomainDto } from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const NeedsDomainsTableColumns =
  (): ColumnConfiguration<NeedsDomainDto>[] => [
    {
      id: 'label',
      value: 'label',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Domain Label',
    },
    {
      id: 'key',
      value: 'key',
      isNumeric: false,
      shouldDisablePadding: false,
      title: 'Key',
    },
  ];
